module.exports = __webpack_public_path__ + "img/whathot_s01.720941cf.png";